import { createFeature } from '@ngrx/store';
import { workspaceSidebarReducer } from './workspace-sidebar-reducer';

export const workspaceSidebarFeature = createFeature({
  name: 'workspaceSidebar',
  reducer: workspaceSidebarReducer,
});
